import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --flex-align-items: center;\n  --flex-flow: row wrap;\n  --spacing: var(--leaf-spacing-16);\n  display: block;\n}\n:host .leaf-c-flex-container--stacked {\n  --flex-align-items: start;\n  --flex-flow: column;\n}\n:host slot {\n  align-items: var(--flex-align-items);\n  display: flex;\n  flex-flow: var(--flex-flow);\n  grid-gap: var(--spacing);\n  width: -moz-fit-content;\n  width: fit-content;\n}\n:host ::slotted(*) {\n  display: contents;\n  flex: 1;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafFlexContainer = class _LeafFlexContainer extends LeafElement {
  constructor() {
    super(...arguments);
    this.stacked = false;
  }
  render() {
    const componentClassName = {
      "leaf-c-flex-container": true,
      "leaf-c-flex-container--stacked": this.stacked
    };
    return html`<div class=${classMap(componentClassName)}><slot part="base"></slot></div>`;
  }
};
_LeafFlexContainer.styles = unsafeCSS(styles);
let LeafFlexContainer = _LeafFlexContainer;
__decorateClass([
  property({ type: Boolean })
], LeafFlexContainer.prototype, "stacked", 2);
export {
  LeafFlexContainer
};
//# sourceMappingURL=flex-container.component.js.map
